import { useQuery } from "@tanstack/react-query";
import { useAuthentication, useIdentityClient } from "@packsize/authentication";
import { useFeatureFlags } from "@packsize/feature-flags";

import { getCompanyRoles, getTenantRoles } from "@/api/identity-api";

export const ROLES_QUERY_KEY = "roles" as const;
export const COMPANY_ROLES_QUERY_KEY = "company-roles" as const;

export const useRoles = () => {
	const { client } = useIdentityClient();
	const { authenticated } = useAuthentication();
	const { isFeatureFlagEnabled } = useFeatureFlags();
	const companyRolesEnabled = isFeatureFlagEnabled("vaporware-company-role-transition");
	const queryFn = companyRolesEnabled ? getCompanyRoles : () => getTenantRoles(client);
	const queryKey = companyRolesEnabled ? COMPANY_ROLES_QUERY_KEY : ROLES_QUERY_KEY;

	return useQuery({
		queryFn,
		queryKey: [queryKey],
		enabled: authenticated === true,
	});
};
